import { matchPath } from 'react-router-dom'

export const UNIVERSE_PATH = '/universe'

export function isGatewayPath(pathname: string) {
  return pathname === '/' || matchPath(UNIVERSE_PATH, pathname) !== null
}
